import axios from 'axios';

interface ImageDownloadPayload {
  imageUrl: string;
  fileName: string;
}

interface PDFDownloadPayload {
  pdfUrl: string;
  fileName: string;
}

const downloadFileFromUrl = ({ data, fileName }: { data: Blob; fileName: string }): void => {
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const downloadImageFromUrl = async ({
  imageUrl,
  fileName,
}: ImageDownloadPayload): Promise<void> => {
  const blob = await axios.get(imageUrl, {
    responseType: 'blob',
  });

  downloadFileFromUrl({ data: new Blob([blob.data]), fileName: `${fileName}.png` });
};

export const downloadPdfFromUrl = async ({
  pdfUrl,
  fileName,
}: PDFDownloadPayload): Promise<void> => {
  const blob = await axios.get(pdfUrl, {
    responseType: 'blob',
  });

  downloadFileFromUrl({ data: new Blob([blob.data]), fileName: `${fileName}.pdf` });
};
